import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('speakiq_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem('speakiq_token');
      localStorage.removeItem('speakiq_user');
      window.location.href = '/login';
    }
    // On admin.speakiq.uk, a 403 means the stored token belongs to the wrong role
    // Clear auth so the user is forced to log in as superadmin
    if (status === 403 && window.location.hostname === 'admin.speakiq.uk') {
      localStorage.removeItem('speakiq_token');
      localStorage.removeItem('speakiq_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
